import { render, staticRenderFns } from "./base-flyout.vue?vue&type=template&id=061e0900&scoped=true"
import script from "./base-flyout.vue?vue&type=script&setup=true&lang=js"
export * from "./base-flyout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-flyout.vue?vue&type=style&index=0&id=061e0900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e0900",
  null
  
)

export default component.exports